import axios from 'axios';

const state = () => ({
  city: 'Владивосток',
  region: '',
});

const mutations = {
  setLocation(state, { city, region }) {
    state.city = city;
    state.region = region;
  },
  setCity(state, city) {
    state.city = city;
  },
};

const actions = {
  async detectLocation({ commit }) {
    if (!navigator.geolocation) {
      console.warn('Геолокация не поддерживается браузером');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        try {
          const response = await axios.get('https://localhost:7243/primgidromet-app/get-location', {
            params: {
              lat: latitude,
              lon: longitude
            }
          });

        // try {
        //   const response = await axios.get('/primgidromet-app/get-location', {
        //     params: {
        //       lat: latitude,
        //       lon: longitude
        //     }
        //   });

          const data = response.data;

          const city = data.address.city || data.address.town || data.address.village || 'Владивосток';
          const region = data.address.state || 'Приморский край';

          commit('setLocation', { city, region });
        } catch (error) {
          console.error('Ошибка при запросе:', error);
        }
      },
      (error) => {
        console.error('Ошибка геолокации:', error.message);
      }
    );
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
